import { AnchorHTMLAttributes, CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';
import { LoadIndicatorView } from '@vivli/shared/views';

export interface LinkButtonViewProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    disabled?: boolean;
    isLoading?: boolean;
    title?: string;
    dataId?: string;
    wrapText?: boolean;
    keepVisitedColor?: boolean;
    style?: CSSProperties;
    children?: any;
}

const defaultButtonStyle: CSSProperties = {
    color: Color.TEXT_DARK_BLUE,
    fontWeight: Size.FontWeight.Bold,
    backgroundColor: Color.TRANSPARENT,
    fontSize: Size.FontSize.Large,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    wordBreak: 'break-word',
    textDecoration: 'underline'
};

const loadIndicatorStyle: CSSProperties = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
};

export const LinkButtonView = ({
    style,
    disabled,
    isLoading,
    children,
    title,
    dataId,
    wrapText,
    keepVisitedColor,
    className,
    ...optionalProps
}: LinkButtonViewProps) => {
    const buttonStyle: CSSProperties = {
        ...defaultButtonStyle,
        cursor: disabled || isLoading ? 'default' : 'pointer',
        pointerEvents: disabled || isLoading ? 'none' : undefined,
        opacity: disabled || isLoading ? Size.HOVER_OPACITY : 1,
        ...style
    };

    const wrapStyle = wrapText ? 'normal' : 'nowrap';
    const buttonClassName = ['link-button-view', keepVisitedColor ? 'link-button-view--keep-visited-color' : '', className ?? '']
        .filter(Boolean)
        .join(' ');

    return (
        <a
            title={title ? title : ''}
            style={buttonStyle}
            className={buttonClassName}
            data-test-id={dataId}
            aria-disabled={disabled || isLoading}
            {...optionalProps}
        >
            {isLoading && <LoadIndicatorView style={loadIndicatorStyle} />}
            <span style={{ visibility: isLoading ? 'hidden' : 'visible', whiteSpace: wrapStyle }}>{children}</span>
        </a>
    );
};
